import { useContext } from "react";

import { DocumentsContextMenuContext } from "./DocumentsContextMenuContext";

export function useDocumentsContextMenu() {
  const context = useContext(DocumentsContextMenuContext);
  if (!context) {
    throw new Error("useDocumentsContextMenu must be used within a DocumentsContextMenuProvider");
  }
  return context;
}
